import { render, staticRenderFns } from "./HargaTahun.vue?vue&type=template&id=46835145&"
import script from "./HargaTahun.vue?vue&type=script&lang=js&"
export * from "./HargaTahun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports